import { BuilderLogEntry } from '@shared/logger/builder_log_entry';
import { LogEntry } from '@shared/logger/log_entry';

export class BuilderLogEntryTerminalClient extends BuilderLogEntry {
  static colorize_column_log_time(color: string, entry: LogEntry) {
    entry.column_log_time_style = `color: ${color}`;
  }

  static colorize_column_time_diff(color: string, entry: LogEntry) {
    entry.column_diff_time_style = `color: ${color}`;
  }

  static colorize_column_bytes(color: string, entry: LogEntry): void {
    entry.column_bytes_style = `color: ${color}`;
  }

  static colorize_column_log_entry_id(color: string, entry: LogEntry): void {
    entry.column_log_entry_id_style = `color: ${color}`;
  }

  static colorize_column_message(color: string, entry: LogEntry): void {
    entry.column_message_style = `color: ${color}`;
  }
}
